/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

/**
 * Status of the card account transaction

- pending: The transaction has been initiated but has not yet been fully processed. The amount and details of the transaction may change while it is in pending status
- posted: The transaction has been posted and is final, for card transactions this means that the transaction has been captured
- declined: The transaction has been rejected / declined (Card Transaction Only)
- void: The transaction has been cancelled
 */
export type CardAccountTransactionStatus = typeof CardAccountTransactionStatus[keyof typeof CardAccountTransactionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountTransactionStatus = {
  pending: 'pending',
  posted: 'posted',
  declined: 'declined',
  void: 'void',
} as const;
